function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "splash-animation",
  clipPath: "url(#clip0)"
}, React.createElement("g", {
  id: "inside-arm"
}, React.createElement("path", {
  id: "Vector",
  d: "M377.697 443.685C377.697 443.685 495.36 429.565 536.542 407.209C577.724 384.854 883.647 374.264 883.647 443.685C883.647 513.106 531.835 543.698 531.835 543.698L347.105 533.109L377.697 443.685Z",
  fill: "#BA8D8D"
}), React.createElement("path", {
  id: "Vector_2",
  opacity: 0.1,
  d: "M377.697 443.685C377.697 443.685 495.36 429.565 536.542 407.209C577.724 384.854 883.647 374.264 883.647 443.685C883.647 513.106 531.835 543.698 531.835 543.698L347.105 533.109L377.697 443.685Z",
  fill: "black"
}), React.createElement("path", {
  id: "Vector_3",
  d: "M411.819 430.742L387.11 502.516L0 507.223V401.326C0 401.326 148.255 367.204 265.918 440.155C265.918 440.155 404.76 423.682 411.819 430.742Z",
  fill: "#188072"
}), React.createElement("path", {
  id: "Vector_4",
  opacity: 0.1,
  d: "M411.819 430.626L387.11 502.401L0 507.107V401.211C0 401.211 148.255 367.088 265.918 440.039C265.918 440.039 404.76 423.567 411.819 430.626Z",
  fill: "black"
})), React.createElement("g", {
  id: "dirt"
}, React.createElement("path", {
  id: "dirt_2",
  d: "M854.404 400.738C854.404 404.748 845.411 407.725 844.527 411.594C843.65 415.431 848.993 421.265 847.302 424.93C845.555 428.677 843.49 432.267 841.131 435.662C838.916 438.834 832.074 438.371 829.269 441.345C826.522 444.046 823.612 446.576 820.556 448.921C817.579 451.397 813.546 451.916 810.161 454.195C806.943 456.362 807.332 464.311 803.772 466.284C800.37 468.17 795.162 466.653 791.471 468.348C787.929 469.975 786.061 475.859 782.274 477.298C778.622 478.685 774.102 478.088 770.24 479.29C766.503 480.453 762.322 480.264 758.406 481.244C754.604 482.195 751.7 487.895 747.744 488.663C743.89 489.412 739.374 487.415 735.388 487.982C731.497 488.536 726.971 483.61 722.967 483.983C719.049 484.348 715.357 486.628 711.344 486.812C707.409 486.993 703.519 488.726 699.505 488.726C695.491 488.726 691.35 492.491 687.416 492.311C683.403 492.126 679.77 486.419 675.852 486.055C671.848 485.682 667.072 491.643 663.18 491.089C659.195 490.522 656.039 484.687 652.185 483.938C648.228 483.17 643.118 487.34 639.315 486.389C635.398 485.409 633.074 478.621 629.336 477.457C625.475 476.256 620.689 477.884 617.037 476.496C613.25 475.057 608.636 475.288 605.093 473.661C601.403 471.966 598.753 467.955 595.351 466.069C591.791 464.096 590.149 459.202 586.931 457.035C583.545 454.755 578.388 455.046 575.411 452.57C572.268 449.956 566.379 449.82 563.727 447.008C560.921 444.033 559.786 439.039 557.572 435.867C555.239 432.527 559.817 425.465 558.188 421.934C556.499 418.27 549.433 416.782 548.556 412.945C547.652 408.939 547.188 404.845 547.172 400.738C547.172 396.728 553.215 393.663 554.099 389.795C554.976 385.958 550.528 380.447 552.219 376.783C553.848 373.252 553.64 367.824 555.973 364.483C558.188 361.312 563.716 360.068 566.521 357.094C569.173 354.282 573.921 353.498 577.064 350.884C580.04 348.409 579.661 340.943 583.046 338.664C586.265 336.497 590.759 335.508 594.319 333.535C597.721 331.649 602.536 331.967 606.226 330.272C609.768 328.645 615.317 331.851 619.104 330.412C622.756 329.024 625.718 325.991 629.579 324.789C633.316 323.626 635.072 314.754 638.988 313.775C642.79 312.824 647.469 314.403 651.425 313.634C655.279 312.885 660.465 319.885 664.45 319.318C668.341 318.764 671.252 309.42 675.255 309.047C679.174 308.682 683.592 313.522 687.605 313.338C691.54 313.157 695.491 315.993 699.505 315.993C703.518 315.993 707.517 312.101 711.451 312.281C715.464 312.466 719.002 317.609 722.92 317.973C726.924 318.346 731.839 310.524 735.731 311.077C739.716 311.645 742.795 317.692 746.649 318.44C750.606 319.209 755.561 315.455 759.365 316.406C763.281 317.385 765.637 323.813 769.375 324.976C773.236 326.178 775.615 330.712 779.267 332.1C783.054 333.539 790.09 326.806 793.633 328.433C797.323 330.128 800.511 333.061 803.913 334.947C807.473 336.92 813.133 335.928 816.352 338.095C819.737 340.374 820.569 346.493 823.546 348.969C826.689 351.583 831.874 352.37 834.526 355.182C837.331 358.156 837.721 363.486 839.936 366.658C842.268 369.998 842.196 374.626 843.824 378.157C845.514 381.821 850.026 384.592 850.902 388.428C851.786 392.296 854.404 396.729 854.404 400.738Z",
  fill: "#3B2906"
})), React.createElement("g", {
  id: "outside-arm"
}, React.createElement("path", {
  id: "Vector_5",
  d: "M430.645 474.277C430.645 474.277 563.604 406.033 649.498 431.919C735.392 457.804 855.408 413.093 869.527 428.389C883.647 443.685 903.649 608.413 734.215 617.826C564.781 627.239 420.056 589.587 420.056 589.587L430.645 474.277Z",
  fill: "#BA8D8D"
}), React.createElement("path", {
  id: "Vector_6",
  d: "M399.334 467.009C399.334 467.009 451.825 463.688 449.471 482.514C447.118 501.34 444.765 647.241 430.645 650.771C416.526 654.301 304.746 654.301 258.858 654.301H0V428.727C0 428.727 183.554 417.799 275.331 463.688C275.331 463.688 385.672 462.095 399.334 467.009Z",
  fill: "#188072"
})), React.createElement("g", {
  id: "stems"
}, React.createElement("path", {
  id: "Vector_7",
  d: "M645.239 114.179C640.224 114.463 635.386 116.137 631.269 119.016C627.152 121.895 623.918 125.863 621.93 130.477C616.102 144.565 623.607 161.115 634.872 171.388C646.138 181.662 660.609 187.534 673.758 195.253C691.418 205.621 707.288 220.013 716.124 238.487C724.961 256.961 725.901 279.845 715.514 297.495C705.873 313.876 688.343 323.68 671.623 332.722",
  stroke: "#3F3D56",
  strokeMiterlimit: 10
}), React.createElement("path", {
  id: "Vector_8",
  d: "M692.304 28.2855C687.289 28.5688 682.451 30.2436 678.334 33.1222C674.217 36.0008 670.984 39.9694 668.996 44.5829C663.167 58.6716 670.672 75.2209 681.937 85.4945C693.203 95.7682 707.674 101.641 720.823 109.359C738.483 119.727 754.353 134.119 763.19 152.593C772.026 171.067 772.966 193.952 762.579 211.601C752.938 227.982 735.408 237.787 718.688 246.829",
  stroke: "#3F3D56",
  strokeMiterlimit: 10
}), React.createElement("path", {
  id: "Vector_9",
  d: "M847.051 48.0406C842.911 45.1941 838.061 43.5571 833.043 43.3129C828.026 43.0687 823.039 44.2271 818.643 46.6581C805.409 54.2304 801.212 71.9103 803.831 86.9305C806.45 101.951 814.298 115.453 819.969 129.606C827.587 148.615 831.325 169.71 827.003 189.727C822.681 209.745 809.415 228.415 790.397 236.012C772.745 243.064 752.882 240.084 734.126 236.999",
  stroke: "#3F3D56",
  strokeMiterlimit: 10
})), React.createElement("g", {
  id: "one"
}, React.createElement("path", {
  id: "first",
  d: "M706.239 232.432C721.835 232.432 734.478 226.291 734.478 218.716C734.478 211.141 721.835 205 706.239 205C690.643 205 678 211.141 678 218.716C678 226.291 690.643 232.432 706.239 232.432Z",
  fill: "#07B387"
})), React.createElement("g", {
  id: "two"
}, React.createElement("path", {
  id: "second",
  d: "M771.867 213.839C787.463 213.839 800.106 207.698 800.106 200.123C800.106 192.548 787.463 186.407 771.867 186.407C756.271 186.407 743.628 192.548 743.628 200.123C743.628 207.698 756.271 213.839 771.867 213.839Z",
  fill: "#4AC2B9"
})), React.createElement("g", {
  id: "three"
}, React.createElement("path", {
  id: "third",
  d: "M800.239 245.432C815.835 245.432 828.478 239.291 828.478 231.716C828.478 224.141 815.835 218 800.239 218C784.643 218 772 224.141 772 231.716C772 239.291 784.643 245.432 800.239 245.432Z",
  fill: "#07B387"
})), React.createElement("g", {
  id: "nine"
}, React.createElement("path", {
  id: "ninth",
  d: "M722.239 128.432C737.835 128.432 750.478 122.291 750.478 114.716C750.478 107.141 737.835 101 722.239 101C706.643 101 694 107.141 694 114.716C694 122.291 706.643 128.432 722.239 128.432Z",
  fill: "#4AC2B9"
})), React.createElement("g", {
  id: "ten"
}, React.createElement("path", {
  id: "tenth",
  d: "M805.989 104.413C821.585 104.413 834.228 98.2721 834.228 90.6969C834.228 83.1217 821.585 76.9807 805.989 76.9807C790.393 76.9807 777.75 83.1217 777.75 90.6969C777.75 98.2721 790.393 104.413 805.989 104.413Z",
  fill: "#07B387"
})), React.createElement("g", {
  id: "eleven"
}, React.createElement("path", {
  id: "eleventh",
  d: "M675.384 74.9973C690.98 74.9973 703.623 68.8564 703.623 61.2812C703.623 53.706 690.98 47.5651 675.384 47.5651C659.788 47.5651 647.145 53.706 647.145 61.2812C647.145 68.8564 659.788 74.9973 675.384 74.9973Z",
  fill: "#188072"
})), React.createElement("g", {
  id: "thirteen"
}, React.createElement("path", {
  id: "thirteenth",
  d: "M693.033 30.2855C708.629 30.2855 721.272 24.1446 721.272 16.5694C721.272 8.99416 708.629 2.85325 693.033 2.85325C677.437 2.85325 664.794 8.99416 664.794 16.5694C664.794 24.1446 677.437 30.2855 693.033 30.2855Z",
  fill: "#07B387"
})), React.createElement("g", {
  id: "twelve"
}, React.createElement("path", {
  id: "twelfth",
  d: "M841.239 57.4322C856.835 57.4322 869.478 50.8436 869.478 42.7161C869.478 34.5886 856.835 28 841.239 28C825.643 28 813 34.5886 813 42.7161C813 50.8436 825.643 57.4322 841.239 57.4322Z",
  fill: "#4AC2B9"
})), React.createElement("g", {
  id: "five"
}, React.createElement("path", {
  id: "fifth",
  d: "M619.239 166.432C634.835 166.432 647.478 160.291 647.478 152.716C647.478 145.141 634.835 139 619.239 139C603.643 139 591 145.141 591 152.716C591 160.291 603.643 166.432 619.239 166.432Z",
  fill: "#4AC2B9"
})), React.createElement("g", {
  id: "seven"
}, React.createElement("path", {
  id: "seventh",
  d: "M822.462 175.011C838.058 175.011 850.701 168.87 850.701 161.294C850.701 153.719 838.058 147.578 822.462 147.578C806.866 147.578 794.223 153.719 794.223 161.294C794.223 168.87 806.866 175.011 822.462 175.011Z",
  fill: "#188072"
})), React.createElement("g", {
  id: "six"
}, React.createElement("path", {
  id: "sixth",
  d: "M762.239 170.432C777.835 170.432 790.478 164.291 790.478 156.716C790.478 149.141 777.835 143 762.239 143C746.643 143 734 149.141 734 156.716C734 164.291 746.643 170.432 762.239 170.432Z",
  fill: "#188072"
})), React.createElement("g", {
  id: "eight"
}, React.createElement("path", {
  id: "eighth",
  d: "M637.732 135.005C653.328 135.005 665.971 128.864 665.971 121.289C665.971 113.714 653.328 107.573 637.732 107.573C622.136 107.573 609.493 113.714 609.493 121.289C609.493 128.864 622.136 135.005 637.732 135.005Z",
  fill: "#07B387"
})), React.createElement("g", {
  id: "four"
}, React.createElement("path", {
  id: "fourth",
  d: "M665.239 198.432C680.835 198.432 693.478 192.291 693.478 184.716C693.478 177.141 680.835 171 665.239 171C649.643 171 637 177.141 637 184.716C637 192.291 649.643 198.432 665.239 198.432Z",
  fill: "#188072"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 886,
  height: 654.301,
  fill: "white"
})));

var SvgSplashAnimation = function SvgSplashAnimation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 886,
    height: 655,
    viewBox: "0 0 886 655",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSplashAnimation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/splash-animation.ab96b6d5.svg";
export { ForwardRef as ReactComponent };